// @ts-nocheck
import CustomerChangeModal from '@/components/modals/customer-change-modal';
import * as Enums from '@/utils/enums';

const InvoiceCustomerChange = ({ open, onClose, invoice, accessStatus, onCustomerChanged }: any) => (
    <CustomerChangeModal
        open={open}
        onClose={onClose}
        itemLabel={invoice.InvoiceNumber}
        moduleLabel="invoice"
        description="Changing the customer reassigns the contact and location on this invoice. You cannot change the customer on an approved invoice or one with linked payments."
        checkUrl={`/Invoice/InvoiceCustomerChangeCheck?invoiceID=${invoice.ID}`}
        changeUrl="/Invoice/InvoiceCustomerChange"
        itemIdKey="InvoiceID"
        itemId={invoice.ID}
        moduleType={Enums.Module.Invoice}
        excludedCustomerID={invoice.CustomerID}
        accessStatus={accessStatus}
        onCustomerChanged={onCustomerChanged}
    />
);

export default InvoiceCustomerChange;
